import { useQuery } from "@tanstack/react-query";

import api from "@/shared/api";
import { Data } from "@/shared/types.ts";
import { AssignOrderEntity } from "@/features/order/types.ts";

export type { AssignOrderEntity };

export function useAssignOrders({}: {}) {
  return useQuery<Data<AssignOrderEntity[]>>({
    queryKey: ["assign_orders"],
    queryFn: () =>
      api.get<Data<AssignOrderEntity[]>>(`/api/v1/orders/created`).json(),
    initialData: { data: [], code: 0, description: "", success: true },
  });
}
